import { companiesCompanyIdCustomDomains } from "@dashboardApi/apis/companiesCompanyIdCustomDomains";

import type { AllRouteEndpoints } from "../routeTypes";

export const postCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdCustomDomains,
];
